import { Fragment, jsx } from "react/jsx-runtime";
import React, { Children, cloneElement } from "react";
import {
  TypographyPrefixedContext
} from "@ingka/typography-shared";
import cx from "classnames";
const TextContext = (props) => {
  const { prefix = "", children, ...rest } = props;
  const typography = new TypographyPrefixedContext(prefix);
  const childArray = Children.toArray(children);
  if (childArray.length === 0) return /* @__PURE__ */ jsx(Fragment, { children });
  const classes = Object.entries(rest).map(([k, v]) => {
    if (k in typography.Context) {
      const feature = typography.Context[k];
      if (typeof v === "boolean" && v && typeof feature === "string") {
        return feature;
      }
      if (typeof v === "string" && typeof feature === "object" && v in feature) {
        return feature[v];
      }
    }
    return "";
  });
  const isReactElement = React.isValidElement(childArray[0]);
  if (childArray.length > 1 || !isReactElement) {
    return /* @__PURE__ */ jsx("div", { className: cx(`${prefix}textcontext-wrapper`, classes.join(" ")), children });
  }
  return cloneElement(childArray[0], {
    className: `${childArray[0].props.className || ""} ${classes.join(" ")}`
  });
};
export {
  TextContext
};
